import { AbstractDTO } from '../abstract';
import { DecodeBase64Pipe } from '@signature-it/ngx-generic/pipes';

export class RuleDTO extends AbstractDTO {
    ruleId: number;
    ruleCode: number;
    name: string;
    description: string;
    validatorMsg: string;
	validatorMsgFm: string;
    ruleJS: string;
	preJS: RuleDTO | null;
	postJS: RuleDTO | null;
    fields: string[] = [];
	_validatorMsgFields: string[] = [];
    calcFields: string[] = [];
    decodeBase64Pipe: any = new DecodeBase64Pipe();

    constructor(attributes?: Object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.ruleId = attributes['ruleId'] || 0;
        this.ruleCode = attributes['ruleCode'] || 0;
        this.name = attributes['name'] || '';
        this.description = attributes['description'] || '';
        this.validatorMsg = attributes['validatorMsg'] || '';
        this.validatorMsgFm = attributes['validatorMsgFm'] || '';
		this.ruleJS = attributes['ruleJS'] ? this.decode(attributes['ruleJS']) || attributes['ruleJS']: '';
		this.preJS = attributes['preJS'] ? RuleDTO.create({ruleJS: attributes['preJS'], calcFields: attributes['calcFields']}): null;
		this.postJS = attributes['postJS'] ? RuleDTO.create({ruleJS: attributes['postJS'], calcFields: attributes['calcFields']}): null;
        this.fields = attributes['fields'] || [];
        this._validatorMsgFields = attributes['validatorMsgFields'] || [];
        this.calcFields = attributes['calcFields'] || [];
    }

    get validatorMsgFields(): string[] {
		return this._validatorMsgFields.length ? this._validatorMsgFields: [this.fields[this.fields.length-1]];
    }

    evalCalcFields(ans, product, data) {
        const self = this;
        let calcFields = {};
        Object.keys(self.calcFields).map(function(key) {
            let c = '(function() {' + self.decode(self.calcFields[key])+ '})()';
            const func = new Function('ans', 'product', 'calc', 'data', `return ${c};`);
            calcFields[key] = func(ans, product, calcFields, data);
        });
        return calcFields;
    }

    decode(value) {
        return this.decodeBase64Pipe.decode(value) || value;
    }
}
